module.exports = __webpack_public_path__ + "img/amx-3.78c10b8f.jpg";